import { render, staticRenderFns } from "./EditTemplate.vue?vue&type=template&id=bd40073e&scoped=true"
import script from "./EditTemplate.vue?vue&type=script&lang=js"
export * from "./EditTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditTemplate.vue?vue&type=style&index=0&id=bd40073e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd40073e",
  null
  
)

export default component.exports